import { fbt } from 'fbtee'
import { Plus, Search } from 'lucide-react'
import { DashedButton } from '../../../components/DashedButton'
import { HeaderLink } from '../../../components/HeaderLink'

const ROW = 'flex flex-1 items-center justify-center gap-1.5 px-3 py-3 text-sm text-muted-foreground hover:text-foreground'

const addLabel = () => fbt('I have tickets', 'Dashed button on the event page that opens the editor for the tickets the viewer bought')
const seekLabel = () => fbt('I need one', 'Dashed button on the event page flagging to the viewer’s crew that they need a ticket')

/**
 * The two ways into the tickets section; either may be absent. Full dashed buttons while the
 * section is otherwise empty, `compact` header links once it shows something.
 */
export function TicketEntryRow({ onAdd, onSeek, compact, disabled }: {
  onAdd?: () => void
  onSeek?: () => void
  compact?: boolean
  disabled?: boolean
}) {
  if (!onAdd && !onSeek) return null
  if (compact) {
    return (
      <div className="flex items-center gap-3">
        {onAdd && <HeaderLink onClick={onAdd} disabled={disabled}>{addLabel()}</HeaderLink>}
        {onSeek && <HeaderLink onClick={onSeek} disabled={disabled}>{seekLabel()}</HeaderLink>}
      </div>
    )
  }
  return (
    <div className="flex gap-2">
      {onAdd && (
        <DashedButton onClick={onAdd} disabled={disabled} className={ROW}>
          <Plus className="size-4 shrink-0" />
          {addLabel()}
        </DashedButton>
      )}
      {onSeek && (
        <DashedButton onClick={onSeek} disabled={disabled} className={ROW}>
          <Search className="size-4 shrink-0" />
          {seekLabel()}
        </DashedButton>
      )}
    </div>
  )
}
